export const localeCodes = ['fa', 'en', 'ar']
export function creative() {
  return {
    enabled: false,
    label: '',
    title: '',
    body: '',
    template: 'text-card',
    theme: 'soft-blue',
    imageAlt: '',
    imageEssential: false,
    primaryAction: {
      id: 'primary', kind: 'internal-link', label: '', url: '', openInNewTab: false,
    },
  }
}
export function blankCampaign() {
  return {
    internalName: '',
    description: '',
    locales: { fa: creative(), en: creative(), ar: creative() },
    displayTimezone: 'Asia/Tehran',
    priority: 50,
    devices: ['mobile', 'desktop'],
    rules: {
      matchMode: 'all', contentTypes: ['article', 'video'], contentIds: [], categoryIds: [], tagIds: [], doctorIds: [], categoryMode: 'any', tagMode: 'any', keywords: [], keywordScope: 'title-and-body', keywordMode: 'any', excludeContentIds: [], excludeCategoryIds: [], excludeTagIds: [], excludeDoctorIds: [], negativeKeywords: [], includeRelatedCategories: false, globalScope: false,
    },
    placement: { mode: 'automatic' },
    frequency: { dismissal: 'tab-session' },
  }
}
export function writePayload(record) {
  const payload = blankCampaign()
  Object.keys(payload).forEach(key => { if (record[key] !== undefined) payload[key] = JSON.parse(JSON.stringify(record[key])) })
  localeCodes.forEach(code => { const value = payload.locales[code]; if (!value) return; ['primaryAction', 'secondaryAction'].forEach(key => { if (value[key] && !value[key].label.trim() && !value[key].url.trim()) delete value[key] }) });
  ['startsAt', 'endsAt'].forEach(key => { if (record[key]) payload[key] = new Date(record[key]).toISOString() })
  if (record.revision) payload.revision = record.revision
  return payload
}
export function errorKey(error) {
  const status = error && error.response && error.response.status
  if (status === 409) return 'conflict'
  if (status === 401 || status === 403) return 'forbidden'
  return 'failed'
}
export function safeSettings(value) {
  const source = value || {}
  const result = { mode: ['automatic', 'manual', 'disabled'].includes(source.mode) ? source.mode : 'automatic', placementMode: ['inherit', 'automatic', 'end'].includes(source.placementMode) ? source.placementMode : 'inherit' }
  if (result.mode === 'manual' && /^[a-f0-9]{24}$/i.test(source.campaignId || '')) result.campaignId = source.campaignId
  return result
}
